import styled from "styled-components";

interface StatusTagProps {
  status: string | undefined;
}

function StatusTag({ status }: StatusTagProps) {

  function getStatusColor() {
    if (status === "Planejada") {
      return { backgroundColor: "#e3f2fd", color: "#1976d2" }
    }
    if (status === "ExecutadaParcialmente") {
      return { backgroundColor: "#fff3e0", color: "#e65100" }
    }
    if (status === "Executada") {
      return { backgroundColor: "#e8f5e9", color: "#2e7d32" }
    }
    if (status === "Atrasada") {
      return { backgroundColor: "#ffebee", color: "#e60000" }
    }
    return { backgroundColor: "#f5f5f5", color: "#616161" }
  }

  function getStatusText() {
    if (status === "AguardandoAtivacao") {
      return "AGUARDANDO ATIVAÇÃO";
    }
    if (status === "Planejada") {
      return "PLANEJADO";
    }
    if (status === "ExecutadaParcialmente") {
      return "EXECUTADO PARCIALMENTE";
    }
    if (status === "Executada") {
      return "EXECUTADO";
    }
    if (status === "Atrasada") {
      return "ATRASADO";
    }
    if (status === "Cancelada") {
      return "CANCELADO";
    }
    return "-";
  }

  return (
    <>
      {status ? (
        <Container style={getStatusColor()}>
          <p>{getStatusText()}</p>
        </Container>
      ) : (
        <span>-</span>
      )}
    </>
  );
}

const Container = styled.div`
  padding: 6px;
  border-radius: 15px;
  font-weight: bold;
`;

export default StatusTag;
